import { render, staticRenderFns } from "./CreatorShopPostPin.vue?vue&type=template&id=1905c6b8&scoped=true"
var script = {}
import style0 from "./CreatorShopPostPin.vue?vue&type=style&index=0&id=1905c6b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1905c6b8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CImg: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CImg/CImg.vue').default})
